interface StatusCard {
  icon: string;
  title: string;
  subtitle: string;
  iconClassName: string;
}

const LoadingActionsBar = ({
  step,
  statusCards,
  className = ''
}: {
  step: number;
  statusCards: StatusCard[];
  className?: string;
}) => {
  const { icon, title, subtitle, iconClassName } = statusCards[step];
  return (
    <div className="fixed top-0 left-0 h-screen w-full z-10 bg-[rgba(0,0,0,0.5)] dark:bg-[rgba(0,0,0,0.65)] ">
      <div
        className={`pb-[env(safe-area-inset-bottom)] flex flex-col items-center justify-center gap-[12px] fixed bottom-0 left-0 right-0 bg-pure-white dark:bg-pure-black pt-[7px] z-10 rounded-t-[20px] px-[24px] shadow-[0_-1px_10px_0_rgba(0,0,0,0.03),_0_-1px_3px_0_rgba(0,0,0,0.08)] dark:shadow-[0_-1px_3px_0_rgba(0,0,0,0.20),_0_-1px_10px_0_rgba(0,0,0,0.24)] ${className}`}
        style={{
          paddingBottom: 'calc(12px + env(safe-area-inset-bottom))'
        }}
      >
        <img src={`/assets/icons/graphic-3d/${icon}.png`} alt="" className={iconClassName} />
        <div className="flex flex-col gap-[4px] items-center leading-none">
          <p
            className={`h-[20px] text-[17px] font-semibold text-text-main-lv2 ${subtitle ? '' : 'mb-[20px]'}`}
          >
            {title}
          </p>
          {subtitle && <p className="h-[18px] text-[15px] text-text-main-lv3">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default LoadingActionsBar;
